/* eslint-disable max-statements */
import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.css";
import InputText from "../../shared/input-text";
import searchIcon from "./images/search-icon.svg";
import Check from "./images/green-check.svg";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";
import NotFound from "./images/not-found.png";
import Info from "./images/info.svg";
const FeatureSpecification = ({
    content,
    isSearchbarFocused = false,
    featuresAndSpecsRef
}) => {
    const { summary = []
    } = content || {};

    const {data: features = []} = content?.features;
    const {data: specifications = []} = content?.specifications;

    const summaryList = summary.map((val) => {
        val.label = val.title;
        return val;
    });

    const summaryData = {"name": "Summary",
        "key": "summary",
        // "status": 4,
        "carData": [...summaryList]
    };
    const specsFeatures = [].concat(summaryData, features, specifications);

    const [searchResults, setSearchResults] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [selectedCategory, setSelectedCategory] = useState({});
    const searchRef = useRef(null);

    const checkForWordSearch = (word = "", wordToBeSearched = "") => {
        if (word.toLowerCase().includes(wordToBeSearched.toLowerCase())) {
            return true;
        }
        return false;
    };
    useEffect(() => {
        if (isSearchbarFocused) {
            window.setTimeout(() => {
                if (searchRef && searchRef.current) {
                    searchRef.current.focus();
                }
            }, NUMBER.ZERO);
        }
    }, [isSearchbarFocused]);
    useEffect(() => {
        if (specsFeatures.length > 0 && Object.keys(selectedCategory).length === 0) {
            setSelectedCategory(specsFeatures[0]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const updateSpecsPopupData = ({ specFeature }) => {
        setSelectedCategory(specFeature);
        setSearchText("");
    };

    const getSearchResults = (searchValue) => {
        const resultList = [];
        specsFeatures.forEach((specFeature) => {
            if (checkForWordSearch(specFeature.name, searchValue)) {
                resultList.push(specFeature);
            } else if (specFeature.carData && specFeature.carData.length) {
                const specFeatureResultData = specFeature.carData.filter((elem) => checkForWordSearch(elem.label, searchValue));
                if (specFeatureResultData && specFeatureResultData.length) {
                    resultList.push({ ...specFeature, carData: specFeatureResultData });
                }
            }
        });
        return resultList;
    };

    const onChangeHandler = (e) => {
        const searchValue = e.target.value;
        const resultList = getSearchResults(searchValue);

        // console.log("result lsit", resultList);

        setSearchResults(resultList);
        setSearchText(searchValue);
        // trackUserTyping(searchValue, source);
    };

    const renderFeatureValue = (feature) => {
        // console.log("---feature----", feature);
        if (feature.status === NUMBER.ONE || feature?.checkbox) {
            return <img width={18} height={18} src={Check} alt="verified" />;
        }
        return <span>{feature.value}</span>;
    };

    const renderSpecsFeaturesList = () => {
        if (specsFeatures && specsFeatures.length) {
            return (<div styleName={"styles.featuresSpecifications"}>
                <div styleName={"styles.categorySection"}>
                    <ul>
                        {specsFeatures.map((specFeature) =>
                            (specFeature &&
                            // specFeature.status === NUMBER.FOUR &&
                                 <li
                                     onClick={() => updateSpecsPopupData({ specFeature })}
                                     key={specFeature.name}
                                     styleName={`${specFeature.name === selectedCategory.name ? "styles.active" : ""}`}>
                                     {specFeature.name}
                                 </li>)
                        )}
                    </ul>
                </div>
                {!!(selectedCategory && selectedCategory.carData && selectedCategory.carData.length)
                    && <div styleName={"styles.featuresSpecificationsDetail"}>
                        <div styleName={"styles.featuresSpecificationsList"}>
                            <ul>
                                {selectedCategory.carData.map((feature) => {
                                    const {toolTipText = ""} = feature || {};
                                    // since several items have similar key & name values, hence react not updating dom properly
                                    return (<li key={feature.name}>
                                        <label>
                                            {feature.label}
                                            {toolTipText && <div styleName={"styles.hovertext"}>
                                                <img src={Info} alt="" />
                                                <div styleName={"styles.paratext styles.top_arrow"}>
                                                    <p>{toolTipText}</p>
                                                </div>
                                            </div>}
                                        </label>
                                        {renderFeatureValue(feature)}
                                    </li>);
                                }

                                )}
                            </ul>
                        </div>
                    </div>}
            </div>);
        }
        return <React.Fragment />;
    };
    // TODO:- Deepak to add tooltip
    const renderSearchResults = () => {
        if (searchResults && searchResults.length) {
            return (<div styleName={"styles.searchResult"}>
                <span>SEARCH RESULTS</span>
                {searchResults.map((searchResult, index) => (<div styleName={"styles.featureList styles.searchList"} key={index}>
                    <h6 styleName={"styles.heading"}>{searchResult.name}</h6>
                    <ul>
                        {!!(searchResult.carData && searchResult.carData.length) &&
                            searchResult.carData.map((elem, subSectionIndex) => {
                                // TODO:sanjeev tooltip css fix
                                const {toolTipText = ""} = elem || {};
                                return (<React.Fragment key={subSectionIndex}>
                                    <li>
                                        <label styleName={"styles.searchResultLabel"}>
                                            {elem.label}
                                            {toolTipText && <div styleName={"styles.hovertext"}>
                                                <img src={Info} alt="" />
                                                <div styleName={"styles.paratext styles.top_arrow"}>
                                                    <p>{toolTipText}</p>
                                                </div>
                                            </div>}
                                        </label>
                                    </li>
                                    <li styleName="styles.searchResultValue">{renderFeatureValue(elem)}</li>
                                </React.Fragment>
                                );
                            })}
                    </ul>
                </div>))}
            </div>);
        }
        return (
            <div styleName={"styles.noResultFound"}>
                {/* <FeatureNoResultFound />; */}
                <img src={NotFound} />
            </div>
        );
    };

    const onBlurCallback = () => {};

    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.leftWrapper"}>
                <h3 styleName={"styles.featureHeading"} ref={featuresAndSpecsRef}>Features & specifications</h3>
                <p styleName={"styles.subHeading"}>Here you'll find key features and specifications of the vehicle, including engine performance, safety elements, and technological integrations, offering a succinct yet thorough understanding of its unique attributes.</p>
            </div>
            <div styleName={"styles.rightSectionWrap"}>
                <div styleName={"styles.headerWrap"}>
                    <div styleName={"styles.header"}>
                        <h4>All features and specifications</h4>
                    </div>
                    <div styleName={"styles.flexCenter"}>
                        <div styleName={"styles.searchWrap"}>
                            <InputText
                                value={searchText}
                                onChange={onChangeHandler}
                                inputRef={searchRef}
                                onBlurCallback={onBlurCallback}
                                // onFocusCallback={focusHandler}
                                placeholder="Search for features and specifications"
                            />
                            <span styleName={"styles.searchIcon"}>
                                <img src={searchIcon} alt="Features" />
                            </span>
                        </div>
                    </div>
                </div>
                {!searchText ? renderSpecsFeaturesList() : renderSearchResults()}
            </div>
        </div>
    );
};

FeatureSpecification.propTypes = {
    content: PropTypes.array,
    selectedCategory: PropTypes.object,
    setFeatureSpecsModalDataConnect: PropTypes.func,
    searchText: PropTypes.string,
    getCustomDimesnionsion: PropTypes.func,
    source: PropTypes.string,
    isSearchbarFocused: PropTypes.bool,
    featuresAndSpecsRef: PropTypes.object
};

export default FeatureSpecification;
